import React from 'react';

import { generateAlbumGradient } from '@/helpers/albumGradient';
import { classNames } from '@/helpers/classNames';
import { getAcronym } from '@/helpers/textTransform';
import { useTeamSongs } from '@/providers/TeamSongsProvider';

import styles from './TeamSongThumbs.module.scss';

type TeamSongThumbsProps = {
	className?: string;
	coverImageClassName?: string;
	teamSongIds: (string | undefined)[];
} & React.HTMLAttributes<HTMLDivElement>;

export const TeamSongThumbs: React.FC<TeamSongThumbsProps> = ({
	teamSongIds,
	className,
	coverImageClassName,
	...divProps
}) => {
	const { findTeamSongsById } = useTeamSongs();
	const classes = classNames([styles['root'], className]);
	const setlistTeamSongs = findTeamSongsById(teamSongIds);

	return (
		<div className={classes} {...divProps}>
			{setlistTeamSongs.map((currentSong) => {
				const albumGradient =
					currentSong && !currentSong.artworkUrl
						? generateAlbumGradient(currentSong.name)
						: null;
				return (
					<div
						className={classNames([
							styles['cover-image'],
							coverImageClassName,
						])}
						style={albumGradient ? albumGradient.style : undefined}
					>
						{currentSong?.artworkUrl ? (
							<img src={currentSong.artworkUrl} />
						) : (
							<span style={albumGradient ? { color: albumGradient.textColor } : undefined}>
								{getAcronym(currentSong?.name[0] || 'Removed')}
							</span>
						)}
					</div>
				);
			})}
		</div>
	);
};
